<mat-toolbar color="primary" class="wrapper">
  <span id="go-back" *ngIf="showGoBackButton">
    <button mat-icon-button (click)="onGoBack.emit()" matTooltip="Go back to the main page" i18n-matTooltip>
      <mat-icon>arrow_back</mat-icon>
    </button>
  </span>
  <span id="title" *ngIf="title">
    {{title}}
  </span>
  <span id="button-see-selected-image-from-file" *ngIf="showButtonShowSelectedImageFromFile">
    <button
      mat-raised-button
      matTooltip="See the image that you have selected to be replaced"
      i18n-matTooltip
      color="accent"
      (click)="onShowSelectedImageFromFile.emit()"
    >
      <mat-icon>visibility</mat-icon>
      <mat-icon>image</mat-icon>
    </button>
  </span>

  <ng-container *ngIf="moreButtons">
    <span id="more-buttons" *ngFor="let button of moreButtons">
      <button
        mat-raised-button
        [matTooltip]="button.tooltip"
        color="accent"
        (click)="button.callback()"
      >
        <ng-container *ngIf="button.buttonText then buttonText else buttonIcons"></ng-container>
        <ng-template #buttonText>
          {{button.buttonText}}
        </ng-template>
        <ng-template #buttonIcons>
          <div  *ngFor="let icon of button.buttonIcons">
            <mat-icon>
              {{icon}}
            </mat-icon>
          </div>
        </ng-template>
      </button>
    </span>
  </ng-container>

  <span id="actions">
    <!--<button mat-raised-button (click)="onSaveFile.emit()" color="accent">Save File</button>-->
    <mat-button-toggle-group>
      <!-- Thanks to uminder @ https://stackoverflow.com/a/58672726/7618184-->
      <button
        *ngIf="showSaveFileButton"
        mat-raised-button
        class="button-save-file"
        color="accent"
        [class.split]="showLoadFileButton"
        (click)="onSaveFile.emit()"
        i18n>
        Save file
      </button>
      <button
        *ngIf="showLoadFileButton"
        mat-raised-button
        class="button-save-file drop-down-button"
        [matMenuTriggerFor]="dropdownMenuOne"
        color="accent"
      >
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </mat-button-toggle-group>

    <mat-menu #dropdownMenuOne="matMenu">
      <button mat-menu-item (click)="onSaveFile.emit()" i18n>Save file</button>
      <button mat-menu-item (click)="onLoadFile.emit()" i18n>Load new file</button>
    </mat-menu>
  </span>
</mat-toolbar>
